import { Fragment } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "beauty-edit-concierge-session";
export const OPEN_EVENT = "concierge:open";

export const getSessionId = () => {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`).replace(/[^A-Za-z0-9_-]/g, "");
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
};

/** Ask the floating concierge to open, optionally pre-filling a question. */
export const openConcierge = (prompt) => window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { prompt } }));

export const fetchHistory = async (sessionId) => {
  const res = await fetch(`${BACKEND}/api/concierge/history?session_id=${encodeURIComponent(sessionId)}`);
  if (!res.ok) return [];
  return (await res.json()).messages;
};

/** POST a message and stream SSE frames back: onDelta(text) per token, resolves with the full reply. Throws on error frames. */
export const streamChat = async (sessionId, message, onDelta) => {
  const res = await fetch(`${BACKEND}/api/concierge/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.ok || !res.body) throw new Error(`concierge ${res.status}`);
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let i;
    while ((i = buffer.indexOf("\n\n")) >= 0) {
      const frame = buffer.slice(0, i).trim();
      buffer = buffer.slice(i + 2);
      if (!frame.startsWith("data:")) continue;
      const ev = JSON.parse(frame.slice(5));
      if (ev.error) throw new Error(ev.error);
      if (ev.delta) {
        full += ev.delta;
        onDelta(full);
      }
    }
  }
  return full;
};

export const findShade = async (profile) => {
  const res = await fetch(`${BACKEND}/api/concierge/shade-finder`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(profile),
  });
  if (!res.ok) throw new Error(`shade-finder ${res.status}`);
  return res.json();
};

const TOKEN = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|\*\*([^*]+)\*\*/g;

/** Tiny markdown: [text](url) links + **bold**; everything else is plain text so model output can never inject markup. */
export const renderRich = (text) => {
  const out = [];
  let last = 0;
  let m;
  while ((m = TOKEN.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index));
    if (m[1]) {
      out.push(
        <a key={m.index} href={m[2]} target="_blank" rel="noreferrer" className="underline decoration-champagne/60 underline-offset-4 transition-colors hover:text-champagne" data-testid="concierge-link">
          {m[1]}
        </a>,
      );
    } else {
      out.push(<strong key={m.index} className="font-medium text-champagne">{m[3]}</strong>);
    }
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out.map((node, i) => <Fragment key={i}>{node}</Fragment>);
};
